import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container } from '../style';
import { Footer } from '../Footer';
import WorkoutProgrammeContent from './Content';
import { Loading } from '../../WithLoading/Loading';
import { REST_EXERCISE_ID } from '../../../../data/constants';
import { WorkoutActionCreators } from '../../../../Store/ActionCreators/WorkoutsActionCreators';
import { BreakDownActionCreators } from '../../../../Store/ActionCreators/BreakdownActionCreators';

class WorkoutProgramme extends Component {
    componentDidMount() {
        const { getWorkoutBreakdown, getWorkout } = this.props;
        const currentWorkoutId = this.props.currentWorkoutId || this.props.match.params.workoutId;

        getWorkout(currentWorkoutId);
        getWorkoutBreakdown(currentWorkoutId);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.currentWorkout && prevProps.currentWorkout !== this.props.currentWorkout) {
            this.props.getWorkout(this.props.currentWorkout);
            this.props.getWorkoutBreakdown(this.props.currentWorkout);
        }
    }

    // joining similar sets
    groupExerciseSets = () => {
        const { breakDowns } = this.props;

        const exercises = breakDowns.filter(
            exercise => exercise.exerciseId !== REST_EXERCISE_ID && exercise.isRound === false,
        );

        // in case there's one exercise - return this exercise
        if (exercises.length === 1) {
            return { 1: { count: 1, exercise: exercises[0] } };
        }

        // in case there're many exercises
        let setNumber = 1;
        let similarSetsNumber = 1;
        let joinedSets = {
            1: { count: 0, exercise: {} },
        };

        for (let i = 0; i < exercises.length - 1; i++) {
            // debugger;
            if (exercises[i].exerciseId === exercises[i + 1].exerciseId) {
                similarSetsNumber++;
                joinedSets[setNumber] = { count: similarSetsNumber, exercise: exercises[i] };
            } else {
                if (joinedSets[setNumber] && joinedSets[setNumber].count > 1) {
                    joinedSets[setNumber + 1] = { count: 1, exercise: exercises[i] };
                    similarSetsNumber = 0;
                    setNumber++;
                } else {
                    joinedSets[setNumber] = { count: 1, exercise: exercises[i] };
                    setNumber++;
                    similarSetsNumber = 0;
                }
            }
            if (i === exercises.length - 2) {
                if (exercises[i].exerciseId === exercises[i + 1].exerciseId) {
                    similarSetsNumber++;
                    joinedSets[setNumber] = {
                        count: similarSetsNumber,
                        exercise: exercises[i + 1],
                    };
                } else {
                    if (joinedSets[setNumber] && joinedSets[setNumber].count > 1) {
                        joinedSets[setNumber + 1] = { count: 1, exercise: exercises[i] };
                        similarSetsNumber = 0;
                        setNumber++;
                    } else {
                        joinedSets[setNumber] = { count: 1, exercise: exercises[i] };
                        setNumber++;
                        similarSetsNumber = 0;
                    }
                }
            }
        }

        return joinedSets;
    };

    render() {
        const { isBreakdownLoading, workoutInfo, workoutOwner } = this.props;
        const breakDowns = this.groupExerciseSets();

        return (
            <Container isEmbed={this.props.isEmbed}>
                <Loading isLoading={isBreakdownLoading || breakDowns.length === 0}>
                    <WorkoutProgrammeContent breakDowns={breakDowns} />
                </Loading>
                <Footer displayBoardType={false} workoutOwner={workoutOwner} workoutInfo={workoutInfo} />
            </Container>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    getWorkout: workoutId => dispatch(WorkoutActionCreators.getByIdRequest(workoutId)),
    getWorkoutBreakdown: workoutId => dispatch(BreakDownActionCreators.getBreakDownByIdRequest(workoutId)),
});

const mapStateToProps = (
    {
        breakdown: {
            statuses: { isBreakdownLoading },
            breakdowns,
            currentWorkoutId,
        },
        workout: {
            currentWorkouts,
            id,
            statuses: { workoutInfoLoading },
            user,
            ...workoutInfo
        },
    },
    props,
) => {
    const workoutId = props.currentWorkoutId || props.match.params.workoutId;
    let workout = {};
    let breakDown = [];

    Object.values(currentWorkouts).forEach(wOut => {
        if (wOut.id == workoutId) workout = { ...wOut };
    });

    Object.keys(breakdowns).forEach(bd => {
        if (bd == workoutId) breakDown = [...breakdowns[bd]];
    });

    return {
        isBreakdownLoading,
        breakDowns: breakDown,
        workoutInfoLoading,
        workoutId: workout.id,
        workoutInfo: workout,
        workoutOwner: workout.user,
        currentWorkout: currentWorkoutId,
    };
};

WorkoutProgramme.defaultProps = {
    breakDowns: [],
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(WorkoutProgramme);



// WEBPACK FOOTER //
// ./src/UI/Containers/GymTv/WorkoutProgramme/index.js